<template>
  <div
    class="main d-flex flex-column align-center justify-center"
    data-tourid="routineQr-printable-landscapeQr"
  >
    <img :src="reverLogoGrayscale" alt="logo" />
    <div class="d-flex" style="margin-top: 100px">
      <QRCode :value="qrUrl" size="370" level="L" v-if="qrUrl" />
      <div
        class="main ml-8 d-flex flex-column align-start justify-start"
        style="width: 500px;"
        data-tourid="routineQr-printable-landscapeQr"
      >
        <span class="blue-grey--text text--darken-3 body1">{{ title }}</span>
        <span class="mt-2 blue-grey--text text--darken-2 body2">{{
          description
        }}</span>

        <div v-if="presetTags.length" class="mt-4">
          <span class="blue-grey--text text--darken-3 body2"
            >{{ $t('common.attribute_other') }}
          </span>
          <div>
            <v-chip
              v-for="tag in presetTags"
              class="me-2 mt-2"
              outlined
              small
              :key="tag._id"
            >
              <span class="blue-grey--text text--darken-2">{{ tag.name }}</span>
            </v-chip>
          </div>
        </div>

        <div
          class="d-flex flex-column align-start mt-4"
          v-if="routineFrequency"
        >
          <span
            class="blue-grey--text text--darken-3 body2"
            v-if="routineType"
            >{{ $t('routines.frequency_label') }}</span
          >
          <v-chip v-if="routineFrequency" class="mt-2" outlined small>
            <span class="blue-grey--text text--darken-2">{{
              $t(`routines.frequency.${routineFrequency}`)
            }}</span>
          </v-chip>
        </div>

        <div class="d-flex flex-column align-start mt-4" v-if="routineType">
          <span
            class="blue-grey--text text--darken-3 body2"
            v-if="routineType"
            >{{ $t('common.type') }}</span
          >
          <v-chip class="mt-2" outlined small>
            <span class="blue-grey--text text--darken-2">{{
              $t(`routines.type.${routineType}`)
            }}</span>
          </v-chip>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import QRCode from 'qrcode.vue'
import reverLogoGrayscale from '@/assets/images/logo-bw.svg'

export default {
  name: 'QRLandscape',

  components: {
    QRCode,
  },
  props: {
    qrUrl: {
      type: String,
      required: true,
    },
    definition: {
      type: Object,
    },
  },
  data() {
    return {
      reverLogoGrayscale,
    }
  },

  computed: {
    title() {
      return this.definition?.name
    },
    description() {
      return this.definition?.description
    },
    categories() {
      return this.definition?.categories
    },
    routineFrequency() {
      return this.definition?.frequency
    },
    routineType() {
      return this.definition?.type
    },
    presetTags() {
      return this.definition?.presetTags
    },
  },
}
</script>
